export default {"src":"/_next/static/media/delivered.44af54ae.svg","height":512,"width":512};